import { PressSection } from '@presentation/components';
import type { FC } from 'react';
import {
  FeaturesSection,
  FreeSection,
  HeroSection,
  QuestionsSection,
  RewardsSection,
  SeriousSection,
  StepsSection,
} from './components';
import * as Styled from './styled';

export const BreederLandingPage: FC = () => {
  return (
    <>
      <HeroSection />

      <Styled.Container>
        <StepsSection />
      </Styled.Container>

      <Styled.Container>
        <FreeSection />
      </Styled.Container>

      <FeaturesSection />

      <Styled.Container>
        <RewardsSection />
      </Styled.Container>

      <Styled.Container>
        <QuestionsSection />
      </Styled.Container>

      <Styled.SpaceTop>
        <PressSection />
      </Styled.SpaceTop>

      <SeriousSection />
    </>
  );
};
